import { OFFER_TYPE } from '../../../../../../views/menu/offers/constants';

export default {
  [OFFER_TYPE.BOGO]: 'Osta 1, saat 1',
  [OFFER_TYPE.FREE_ITEM]: 'Ilmainen tuote',
  [OFFER_TYPE.AMOUNT_OFF]: 'Summa-alennus',
  [OFFER_TYPE.PERCENTAGE_OFF]: 'Prosenttialennus',
};
